import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: "'Source Sans 3', sans-serif",
    fontSize: 14,
  },
});

export default theme;